<!-- Дополнительный титул в том же визуальном языке статусов, что и Т1–Т4. -->
<template>
  <EdoDocumentTitleFlowStep
    :label="item.label"
    :note="note"
    :tone="item.tone"
    :selected="selected"
    :aria-label="ariaLabel"
    :tooltip="tooltip"
    @select="$emit('select')"
  />
</template>

<script>
import EdoDocumentTitleFlowStep from "@/components/Edo/shared/EdoDocumentTitleFlowStep.vue";

export default {
  name: "EdoDocumentAdditionalTitleCard",

  components: {
    EdoDocumentTitleFlowStep,
  },

  emits: ["select"],

  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    note() {
      return [this.item.title, this.item.role].filter(Boolean).join(" · ");
    },

    ariaLabel() {
      return [this.item.label, this.item.title, this.item.statusLabel, this.item.role]
        .filter(Boolean)
        .join(". ");
    },

    tooltip() {
      return {
        title: [this.item.label, this.item.title].filter(Boolean).join(" · "),
        tone: this.item.tone,
        statusLabel: this.item.statusLabel,
        participant: this.item.role,
        description: this.item.description,
      };
    },
  },
};
</script>
